import { render } from "./BaseSpinner.vue?vue&type=template&id=fa981636&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=fa981636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa981636"]])

export default __exports__